// @flow
import * as React from 'react';
import { Typography } from '@mui/material';
import {Check, Close} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {
  DataGrid,
  DataGridColumn,
  useAgentCallAgenda
} from '../../../shared';
import { AgentAvailabilityStateOutput } from '@coverright/data-access/types/enrollment';
import { getRoute } from '../../../app/router';

export function RoundRobinState() {
  const {state: data} = useAgentCallAgenda()
  const agents = data?.agentsSorted || [];

  return (
    <DataGrid columns={columns}
              page={0}
              total={agents.length}
              hidePaginator
              rowsPerPage={1000}
              loading={!data}
              rows={agents}/>
  );
}


const columns: DataGridColumn<AgentAvailabilityStateOutput, keyof AgentAvailabilityStateOutput>[] = [
  {
    title: 'Email',
    value: v => v.agentEmail,
  },
  {
    title: 'DontDisturb',
    value: v => v.dontDisturb ? <Check color={'success'} /> : <Close color={'error'} />
  },
  {
    title: 'Excluded',
    value: v => v.excludedFromRoundRobin ? 'Yes' : 'No'
  },
  {
    title: 'Available For New Leads',
    value: v => v.isAvailableForNewLeads ? 'Yes' : 'No'
  },
  {
    title: 'On call',
    value: v => v.onCall ? (
      <Typography component={Link}
                  color={'textPrimary'}
                  sx={{textDecoration: 'underline'}}
                  to={`/${getRoute('client')}/${v.onCallWithClient?.clientId}`}>
        With ${v.onCallWithClient?.clientName}
      </Typography>
    ) : <Close color={'error'} />
  },
  {
    title: 'Online',
    value: v => v.online ? <Check color={'success'} /> : <Close color={'error'} />
  },

]
